import { Component, OnInit, TemplateRef } from '@angular/core';
import { MedicoService } from './../../shared/servicio/medico/medico.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { HttpClient } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-formulas',
  templateUrl: './formulas.component.html',
  styleUrls: ['./formulas.component.css'],
})
export class FormulasComponent implements OnInit {
  modalRef: BsModalRef;
  idmedic;
  formulaTabla: any = [];
  formulaTablaDiagnostico: any = [];

  form;

  config = {
    animated: true,
    class: 'modal-xl modal-dialog-centered',
    backdrop: true,
    ignoreBackdropClick: true,
  };

  configModalDetalle = {
    animated: true,
    class: 'modal-xl modal-dialog-centered',
    backdrop: true,
    ignoreBackdropClick: true,
  };

  constructor(
    private medic: MedicoService,
    private modalService: BsModalService,
    private _http: HttpClient,
    private formbuilder: FormBuilder
  ) {}

  formulamedicos: any = [];

  showLoading: boolean = true;
  page = 1;
  limit = 1;
  count = 0;
  product__name: string;
  product__ean_code: string;
  product__maker: string;
  provider: string;

  medicoModal;

  ngOnInit() {
    this.showLoading = true;

    this.getMedicFormula();
  }

  getMedicFormula() {
    this._http.get(environment.Api_get_user).subscribe(
      (data) => {
        this.medic
          .formulaMedic(data['idmedic'], this.page)
          .toPromise()
          .then((data) => {
            console.log(data);
            this.limit = Math.ceil(data['count']);
            this.count = data['count'];
            this.formulamedicos = data['results'];
            this.showLoading = false;
          })
          .catch((error) => console.log(error));
      },
      (error) => {
        console.log(error);
      }
    );
  }

  pageChanged(p) {
    this.page = p.page;
    this.getMedicFormula();
  }

  add_formula(template: TemplateRef<any>) {
    this._http.get(environment.Api_get_user).subscribe(
      (data) => {
        this.medicoModal = data;
        this.modalRef = this.modalService.show(template, this.config);
      },
      (error) => {
        console.log(error);
      }
    );
  }
  patientChange($event) {
    this.modalRef.hide();
    // this.createPatient.emit(true);
  }

  async AbrirModal(template: TemplateRef<any>, item) {
    this.showLoading = true;

    this.medic
      .formulaDetail(item.id)
      .toPromise()
      .then((data: any) => {
        this.formulaTabla = data['formuladetail_set'];
        this.formulaTablaDiagnostico = data['diagnostic'];

        this.form = this.formbuilder.group({
          cc_doc: [data.medic_idoc],
          cc_pac: [data.patient_idoc],
          medic_name: [data.medic_first_name.concat(' ', data.medic_last_name)],
          patient_name: [
            data.patient_first_name.concat(' ', data.patient_last_name),
          ],

          profesional_license: [data.profesional_license],
          date_created: [data.date_created],
        });

        this.modalRef = this.modalService.show(
          template,
          this.configModalDetalle
        );
        this.showLoading = false;

        //Swal.close();
      })

      .catch((error) => console.log(error));
  }

  reload(r) {
    this.modalRef.hide();
    this.getMedicFormula();
  }
}
